"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.day = void 0;
const enums_1 = require("@bemlo/enums");
exports.day = {
    [enums_1.Day.MONDAY]: 'Monday',
    [enums_1.Day.TUESDAY]: 'Tuesday',
    [enums_1.Day.WEDNESDAY]: 'Wednesday',
    [enums_1.Day.THURSDAY]: 'Thursday',
    [enums_1.Day.FRIDAY]: 'Friday',
    [enums_1.Day.SATURDAY]: 'Saturday',
    [enums_1.Day.SUNDAY]: 'Sunday',
};
